module.exports = __webpack_public_path__ + "img/quality-02-portrait.0570ba39.jpg";